import { FunctionComponent, ReactNode } from 'react'
import classnames from 'classnames'

import Icon, { IconName } from 'components/ui/icon'
import accountCss from '../account.module.scss'

/** A block of the account page: icon + title on top, content below. */
const AccountSection: FunctionComponent<{
  icon: IconName
  title: string
  danger?: boolean
  className?: string
  children: ReactNode
}> = ({ icon, title, danger, className, children }) => (
  <section className={classnames(accountCss.section, className)}>
    <h2 className={classnames(accountCss.sectionTitle, danger && accountCss.danger)}>
      <Icon name={icon} />
      {title}
    </h2>
    <div className={accountCss.sectionBody}>{children}</div>
  </section>
)

export default AccountSection
